import { Component } from '@angular/core';

@Component({
  selector: 'plm-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'plm';
}
